var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49935 0.791504C4.68997 0.791504 0.791016 4.69046 0.791016 9.49984C0.791016 14.3092 4.68997 18.2082 9.49935 18.2082C14.3087 18.2082 18.2077 14.3092 18.2077 9.49984C18.2077 4.69046 14.3087 0.791504 9.49935 0.791504ZM13.274 8.02734C13.3435 7.94789 13.3964 7.85534 13.4296 7.75514C13.4629 7.65493 13.4757 7.5491 13.4674 7.44387C13.4591 7.33863 13.4298 7.23612 13.3813 7.14235C13.3328 7.04859 13.2661 6.96548 13.185 6.8979C13.1039 6.83032 13.0101 6.77964 12.9091 6.74884C12.8082 6.71805 12.7021 6.70776 12.597 6.71858C12.492 6.72939 12.3903 6.7611 12.2977 6.81184C12.2051 6.86257 12.1236 6.93131 12.058 7.014L8.65385 11.0982L6.89239 9.33596C6.74308 9.19175 6.5431 9.11196 6.33553 9.11376C6.12796 9.11557 5.9294 9.19882 5.78262 9.34561C5.63584 9.49239 5.55258 9.69095 5.55077 9.89852C5.54897 10.1061 5.62877 10.3061 5.77297 10.4554L8.14797 12.8304C8.22576 12.9081 8.31889 12.9688 8.42143 13.0086C8.52396 13.0483 8.63366 13.0663 8.74352 13.0613C8.85338 13.0563 8.961 13.0285 9.05951 12.9796C9.15802 12.9307 9.24526 12.8618 9.31568 12.7773L13.274 8.02734Z",
    fill: "#82BE41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.427d7d2da53de85d0a748eab63b4ac1e.svg";
export { ForwardRef as ReactComponent };